import { GpsOnly } from '@kinomap-dev/ng-ui-lib';

export class GpsState {
  gpsTracks: GpsOnly[] = [];
  isLoadingGpsTracks: boolean = false;
  areGpsTracksComplete: boolean = false;
}
